<template>
    <search-autocomplete
        v-model="userId"
        label="number_name"
        value-key="id"
        state-name="pages/responsibles"
        v-bind="$attrs"
        :dusk="dusk"
        @focus="$emit('focus', $event)"
        :search-method="responsibleSearch">
        <template v-if="showEmailAndPhone" v-slot="props">
            <span class="search__result">
                <span class="search__result-item search__result-id">{{ props.item.id }}</span>
                <span class="search__result-item search__result-name">{{ props.item.name }}</span>
                <span class="search__result-item search__result-email" v-if="props.item.email">{{ props.item.email }}</span>
                <span class="search__result-item search__result-phone" v-if="props.item.phone">{{ props.item.phone }}</span>
            </span>
        </template>
        <template v-else v-slot="props">
            {{ props.item.number_name }}
        </template>
    </search-autocomplete>
</template>

<script>
import { mapActions } from 'vuex';
import SearchAutocomplete from "../SearchAutocomplete";

export default {
    name: "SearchResposible",
    components: {SearchAutocomplete},
    props: {
        value: {
            requested: true,
            default: () => ''
        },
        showEmailAndPhone: {
            type: Boolean,
            default: false
        },
        dusk: {
            type: String,
            default: 'searchResposible'
        }
    },
    data: () => ({
        userId: '',
    }),
    watch: {
        value(val) {
            this.$set(this, 'userId', val);
        },
        userId(val) {
            this.$emit('input', val);
        }
    },
    methods: {
        ...mapActions('pages', [
            'responsibleSearch'
        ])
    },
    mounted() {
        this.$set(this, 'userId', this.value);
    }
}
</script>
